import { Spin } from "antd";
import React from "react";
import new_logo from "../../assets/new_logo.png";
import { Col } from "react-bootstrap";

export default function Loading() {
  return (
    <div className="vh-100 d-flex justify-content-center align-items-center">
      <Col className="d-flex flex-column align-items-center">
        <img src={new_logo} width="8%" alt="Logo" className="mb-4" />
        <Spin />
      </Col>
    </div>
  );
}
